var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "51FD747A-5723-4F71-9153-22BEED686399") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VertexAiPage",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "VertexAILanding",
    transform: "translate(-503.000000, -521.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(87.000000, 171.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-15",
    transform: "translate(36.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bubble-1",
    transform: "translate(0.000000, 221.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M392.59,99 L390,101.59 L387.41,99 L386,100.41 L388.59,103 L386,105.59 L387.41,107 L390,104.41 L392.59,107 L394,105.59 L391.41,103 L394,100.41 L392.59,99 Z M390,93 C384.47,93 380,97.47 380,103 C380,108.53 384.47,113 390,113 C395.53,113 400,108.53 400,103 C400,97.47 395.53,93 390,93 Z M390,111 C385.59,111 382,107.41 382,103 C382,98.59 385.59,95 390,95 C394.41,95 398,98.59 398,103 C398,107.41 394.41,111 390,111 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.d945050e107b341e3b833d7a2acc6cec.svg";
export { ForwardRef as ReactComponent };